import type { AccRechargeRewardType } from '@/types/mall'

export const oneYearRechargeReward: AccRechargeRewardType[] = [
  {
    level: 1,
    needCount: 10000,
    reward: { crystal: 2000 },
  },
  {
    level: 2,
    needCount: 30000,
    reward: { crystal: 2000 },
  },
  {
    level: 3,
    needCount: 50000,
    reward: { crystal: 3000 },
  },
  {
    level: 4,
    needCount: 100000,
    reward: { crystal: 8000 },
  },
  {
    level: 5,
    needCount: 150000,
    reward: { crystal: 10000 },
  },
  {
    level: 6,
    needCount: 200000,
    reward: { crystal: 15000 },
  },
  {
    level: 7,
    needCount: 300000,
    reward: { crystal: 20000 },
  },
]

export const resistanceRewardList = [
  {
    count: 20,
    point: 800,
  },
  {
    count: 50,
    point: 600,
  },
  {
    count: 100,
    point: 500,
  },
  {
    count: 200,
    point: 300,
  },
  {
    count: 300,
    point: 300,
  },
  {
    count: 500,
    point: 200,
  },
  {
    count: 666,
    point: 0,
  },
]

export const nianMonsterRewardList = [
  {
    count: 3,
    point: 800,
  },
  {
    count: 5,
    point: 600,
  },
  {
    count: 8,
    point: 500,
  },
  {
    count: 10,
    point: 300,
  },
  {
    count: 12,
    point: 300,
  },
  {
    count: 16,
    point: 0,
  },
]

export const mooncakeList = [
  {
    id: 1,
    name: '劣质饺子',
    needCount: 1,
    classes: 'normal',
    ad: 1,
  },
  {
    id: 2,
    name: '普通饺子',
    needCount: 5,
    classes: 'race',
    ad: 3,
  },
  {
    id: 3,
    name: '精致饺子',
    needCount: 10,
    classes: 'epic',
    ad: 5,
  },
  {
    id: 4,
    name: '豪华饺子',
    needCount: 20,
    classes: 'legend',
    ad: 8,
  },
]

export const petAttrIntro: Record<string, string> = {
  601: '攻击',
  602: '攻击速度',
  603: '暴击',
  604: '爆伤',
  605: '破防',
  606: '命中',
}
